export const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME;
export const PLATFORM_CODE = process.env.REACT_APP_PLATFORM_CODE;
export const PLATFORM_LOGO = process.env.REACT_APP_PLATFORM_LOGO_URL;
export const PLATFORM_BANNER_URL = process.env.REACT_APP_PLATFORM_BANNER_URL;
export const CHATWOOT_TOKEN = process.env.REACT_APP_CHATWOOT_TOKEN;
export const CHATWOOT_URL = process.env.REACT_APP_CHATWOOT_URL;
